// Generado automáticamente en cada compilación
export const CURRENT_BUILD = {
  "version": "1.0.0",
  "buildTime": 1793562128999,
  "buildDate": "2026-11-01T19:42:08.999Z"
};
export const APP_VERSION = '1.0.0';
